import { BroadcastPort } from '../ports'

export class BroadcastAdapter implements BroadcastPort {
  private channelMap: Map<
    `${(typeof BroadcastAdapter)['CHANNEL_NAME_PREFIX']}_${string}`,
    BroadcastChannel
  > = new Map()
  static CHANNEL_NAME_PREFIX = 'EPRIVACY_CHANNEL' as const

  send(channelName: string): void {
    this.getChannel(channelName)?.postMessage(undefined)
  }

  receive(
    channelName: string,
    onMessage: (messageEvent: MessageEvent<undefined>) => void,
    once: boolean = false
  ): void {
    this.getChannel(channelName)?.addEventListener(
      'message',
      (event: MessageEvent<undefined>) => onMessage(event),
      { once }
    )
  }

  private getChannel(channelName: string) {
    const prefixedChannelName = this.createPrefixedChannelName(channelName)
    let channel = this.channelMap.get(prefixedChannelName)
    if (!channel && BroadcastChannel) {
      channel = new BroadcastChannel(prefixedChannelName)
      this.channelMap.set(prefixedChannelName, channel)
    }
    return channel
  }

  private createPrefixedChannelName(message: string) {
    return `${BroadcastAdapter.CHANNEL_NAME_PREFIX}_${message}` as const
  }
}
